// src/App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Layout from './components/Layout';
import LoadingFallback from './components/LoadingFallback';
import './i18n';

// Lazy-loaded pages para code splitting
const Home = lazy(() => import('./pages/Home'));
const Club = lazy(() => import('./pages/Club'));
const Tienda = lazy(() => import('./pages/Tienda'));
const Contacto = lazy(() => import('./pages/Contacto'));
const Eventos = lazy(() => import('./pages/Eventos'));
const Recap = lazy(() => import('./pages/Recap'));
const RecapDetailTimeline = lazy(() => import('./pages/RecapDetailTimeline'));
const Privacidad = lazy(() => import('./pages/Privacidad'));
const Cookies = lazy(() => import('./pages/Cookies'));
const Soporte = lazy(() => import('./pages/Soporte'));
const AltaSocio = lazy(() => import('./pages/AltaSocio'));
const AltaResultado = lazy(() => import('./pages/AltaResultado'));
const RuntriPhoneRedirect = lazy(() => import('./pages/RuntriPhoneRedirect'));
const CanalRuntriRedirect = lazy(() => import('./pages/CanalRuntriRedirect'));
const EventoInscripcionIOS = lazy(() => import('./pages/EventoInscripcionIOS'));

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/runtriphone" element={
          <Suspense fallback={<LoadingFallback />}>
            <RuntriPhoneRedirect />
          </Suspense>
        } />
        <Route path="/canal" element={
          <Suspense fallback={<LoadingFallback />}>
            <CanalRuntriRedirect />
          </Suspense>
        } />
        <Route element={<Layout />}>
          {/* Suspense boundary para todas las páginas lazy-loaded */}
          <Route path="/" element={
            <Suspense fallback={<LoadingFallback />}>
              <Home />
            </Suspense>
          } />
          <Route path="/club" element={
            <Suspense fallback={<LoadingFallback />}>
              <Club />
            </Suspense>
          } />
          <Route path="/tienda" element={
            <Suspense fallback={<LoadingFallback />}>
              <Tienda />
            </Suspense>
          } />
          <Route path="/contacto" element={
            <Suspense fallback={<LoadingFallback />}>
              <Contacto />
            </Suspense>
          } />
          <Route path="/eventos" element={
            <Suspense fallback={<LoadingFallback />}>
              <Eventos />
            </Suspense>
          } />
          <Route path="/recap" element={
            <Suspense fallback={<LoadingFallback />}>
              <Recap />
            </Suspense>
          } />
          <Route path="/resumen/:mes" element={
            <Suspense fallback={<LoadingFallback />}>
              <RecapDetailTimeline />
            </Suspense>
          } />
          <Route path="/privacidad" element={
            <Suspense fallback={<LoadingFallback />}>
              <Privacidad />
            </Suspense>
          } />
          <Route path="/cookies" element={
            <Suspense fallback={<LoadingFallback />}>
              <Cookies />
            </Suspense>
          } />
          <Route path="/soporte" element={
            <Suspense fallback={<LoadingFallback />}>
              <Soporte />
            </Suspense>
          } />
          <Route path="/alta" element={
            <Suspense fallback={<LoadingFallback />}>
              <AltaSocio />
            </Suspense>
          } />
          <Route path="/alta/resultado" element={
            <Suspense fallback={<LoadingFallback />}>
              <AltaResultado />
            </Suspense>
          } />
          <Route path="/evento-inscripcion" element={
            <Suspense fallback={<LoadingFallback />}>
              <EventoInscripcionIOS />
            </Suspense>
          } />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
